import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import H6 from '@base/H6/H6';
import Link from '@base/Link/Link';
import P2 from '@base/P2/P2';
import dateHelper from '@utils/dates';
import ItemModel from '@models/Item';
import CheckBig from '@icon/CheckBig';
import { Spacings } from '@styles/index';
import pushRoute from '@utils/pushRoute';

const Wrapper = styled.div`
  grid-column: span 8;
  display: flex;
  padding: ${Spacings.SPACING_4B} ${Spacings.SPACING_4B};
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: var(--color-shadow);
`;

const RankWrapper = styled.div`
  width: 40px;
  padding-right: ${Spacings.SPACING_3B};
  margin: auto 0px;
`;
const LessonWrapper = styled.div`
  flex-grow: 1;
`;

const StyP2 = styled(P2)`
  margin-top: ${Spacings.SPACING_1B};
  color: var(--color-text-primary);
`;

const FreeLessonCard = ({
  lesson,
  lessonRank,
  watchingUID,
  onClick,
  isMobile,
  className
}) => {
  const { watched, hasAttempted, attempted } = lesson;
  const hasWatched = watched || hasAttempted || attempted;
  const renderRankContent = (hasWatchedLesson) => {
    if (hasWatchedLesson) return <CheckBig color="var(--color-i-green)" />;
    return <H6 color="var(--color-text-primary)">{lessonRank}</H6>;
  };

  const renderLessonTitle = (hasWatchedLesson, watchingLessonUID) => {
    let color = 'var(--color-text-primary)';
    if (lesson.uid === watchingLessonUID) color = 'var(--color-i-green)';
    else if (hasWatchedLesson) color = 'var(--color-text-secondary)';

    return (
      <P2 lineClamp={2} color={color}>
        {lesson.name || lesson.title}
      </P2>
    );
  };

  const handleClick = (e, asLink) => {
    if (e) e.preventDefault();
    if (isMobile) onClick();
    pushRoute(asLink);
  };

  const duration =
    lesson.videoDuration || lesson.video?.duration || lesson.duration || 0;
  const lessonDuration = dateHelper.formatMinutesFromSeconds(duration);

  const { asLink, hrefLink } = ItemModel.getAsAndHrefOfLesson(lesson);

  return (
    <Link href={hrefLink} as={asLink} onClick={(e) => handleClick(e, asLink)}>
      <Wrapper className={className}>
        <RankWrapper>{renderRankContent(hasWatched)}</RankWrapper>
        <LessonWrapper>
          {renderLessonTitle(hasWatched, watchingUID)}
          <StyP2 color="var(--color-text-secondary)">{lessonDuration}</StyP2>
        </LessonWrapper>
      </Wrapper>
    </Link>
  );
};
export default FreeLessonCard;
FreeLessonCard.propTypes = {
  lesson: PropTypes.objectOf(PropTypes.any).isRequired,
  watchingUID: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
  className: PropTypes.string,
  lessonRank: PropTypes.number.isRequired
};

FreeLessonCard.defaultProps = {
  isMobile: false,
  className: ''
};
